import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface EmptyStateProps {
  icon?: ReactNode
  title: string
  children?: ReactNode
  action?: ReactNode
  className?: string
}

export function EmptyState({ icon, title, children, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center rounded-card border border-dashed border-line-strong bg-ink-900/60 px-6 py-14 text-center',
        className,
      )}
    >
      {icon && <div className="mb-4 grid size-12 place-items-center rounded-2xl bg-white/[0.06] text-fg-muted">{icon}</div>}
      <h2 className="text-xl font-semibold">{title}</h2>
      {children && <div className="mt-2 max-w-md text-fg-muted">{children}</div>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  )
}
